import Navbar from "@/components/gala/Navbar";
import Hero from "@/components/gala/Hero";
import MenuSection from "@/components/gala/MenuSection";
import ProgramTimeline from "@/components/gala/ProgramTimeline";
import PhotoGallery from "@/components/gala/PhotoGallery";
import RSVPForm from "@/components/gala/RSVPForm";
import DocumentsHub from "@/components/gala/DocumentsHub";
import Footer from "@/components/gala/Footer";

export default function EventPage() {
  return (
    <div className="relative text-[#F8F1DC]">
      <Navbar />
      <main>
        <Hero />
        <ProgramTimeline />
        <MenuSection />
        <PhotoGallery />
        <RSVPForm />
        <DocumentsHub />
      </main>
      <Footer />
    </div>
  );
}
